












import Vue from 'vue'
import CContactForm from '~/components/shared/configurable/CContactForm.vue'

export default Vue.extend({
  name: 'InfoContact',
  components: {
    CContactForm
  },
  computed: {
    url() {
      return '/api/information/contact/'
    }
  }
})
